import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Info, LogOut, Menu, Swords, User, X } from 'lucide-react';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/config';
import { useAppContext } from '../../context/AppContext';
import { displayName } from '../../utils/calculations';
import PlayerAvatar from '../ui/PlayerAvatar';

const Header = ({ showBack, onBack, rightAction }) => {
  const { profile } = useAppContext();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  if (!profile) return null;

  const handleLogout = async () => {
    await signOut(auth);
  };

  return (
    <header className="px-6 py-4 bg-white sticky top-0 z-20 border-b border-slate-100 flex justify-between items-center">
      {showBack ? (
        <button onClick={onBack} className="flex items-center text-slate-500 hover:text-blue-600 p-2 -ml-2 rounded-lg"><ArrowLeft className="w-5 h-5 mr-1" /> Voltar</button>
      ) : (
        <div className="flex items-center gap-3">
          <div onClick={() => navigate('/profile')} className="cursor-pointer hover:opacity-80">
            <PlayerAvatar user={profile} size="md" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-slate-800 leading-tight">Olá, {displayName(profile.name, true)}</h1>
            <p className="text-xs text-slate-400 cursor-pointer hover:text-blue-500" onClick={() => navigate('/profile')}>Editar perfil</p>
          </div>
        </div>
      )}

      {rightAction ? rightAction : <>
        <button onClick={() => setMenuOpen(open => !open)} className="p-2 bg-slate-50 rounded-full text-slate-500 hover:text-blue-600 ml-auto lg:hidden" aria-label="Abrir menu">
          {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
        <button onClick={handleLogout} className="hidden lg:block p-2 bg-slate-50 rounded-full text-slate-400 hover:text-red-500 ml-auto"><LogOut className="w-5 h-5" /></button>
        {menuOpen && <div className="absolute top-full right-4 mt-2 w-52 bg-white rounded-2xl border border-slate-100 shadow-xl p-2 lg:hidden">
          {[
            { path: '/profile', label: 'Perfil', icon: User },
            { path: '/duels', label: 'Confrontos', icon: Swords },
            { path: '/about', label: 'Sobre', icon: Info },
          ].map(({ path, label, icon: Icon }) => <button key={path} onClick={() => { setMenuOpen(false); navigate(path); }} className="w-full flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium text-slate-600 hover:bg-slate-50"><Icon className="w-4 h-4 text-blue-500" />{label}</button>)}
          <div className="border-t border-slate-100 my-1" />
          <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-3 rounded-xl text-sm font-medium text-red-500 hover:bg-red-50"><LogOut className="w-4 h-4" />Sair da conta</button>
        </div>}
      </>}
    </header>
  );
};

export default Header;
